import {useNavigate} from 'react-router-dom';
import {useForm} from 'react-hook-form';
import {useState} from 'react';

import {RootState} from '@/store';
import {useAppDispatch, useAppSelector} from '@/hooks/redux.ts';
import {login} from '@/store/authSlice.ts';
import {Button} from "@/components/ui/Button.tsx";
import {Toast} from '@/components/ui/Toast';
import {ToastState} from "@/components/auth/types/register.types.ts";

import {AssistantLabTitle} from "@/assets/Logos.tsx";
import {
    Container,
    Form,
    Label,
    Input,
    ErrorMessage,
    RegistrationLink,
    StyledTable
} from '@/components/auth/styles/LoginForm.styles';

export const LoginForm = () => {
    const [error, setError] = useState<string>('');
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const {isLoading} = useAppSelector((state: RootState) => state.auth);
    const [toast, setToast] = useState<ToastState>({
        show: false,
        message: '',
        type: 'success'
    });

    const {register, handleSubmit, formState: {errors}} = useForm({
        defaultValues: {
            email: '',
            password: ''
        }
    });

    const onSubmit = async (data: { email: string; password: string }) => {
        try {
            await dispatch(login(data)).unwrap();
            setToast({
                show: true,
                message: 'Вход выполнен успешно! Перенаправление...',
                type: 'success'
            });
            setTimeout(() => {
                navigate('/dashboard');
            }, 1500);
        } catch {
            setError('Неверный email или пароль')
        }
    };

    return (
        <Container>
            {toast.show && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    onClose={() => setToast(prev => ({...prev, show: false}))}
                />
            )}
            <Form onSubmit={handleSubmit(onSubmit)}>
                <StyledTable>
                    <tr>
                        <td/>
                        <td><AssistantLabTitle/></td>
                    </tr>
                    <tr>
                        <td><Label>Email</Label></td>
                        <td>
                            <Input
                                type="email"
                                {...register('email', {
                                    required: 'Email is required',
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: 'Invalid email address'
                                    }
                                })}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td><Label>Password</Label></td>
                        <td>
                            <Input
                                type="password"
                                {...register('password', {
                                    required: 'Password is required',
                                    minLength: {
                                        value: 8,
                                        message: 'Password must be at least 8 characters'
                                    }
                                })}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td/>
                        <td>
                            {(!!error || errors.email || errors.password) && (
                                <ErrorMessage>
                                    {(error || errors.email?.message || errors.password?.message) as string}
                                </ErrorMessage>
                            )}

                            <Button
                                type="submit"
                                variant="primary"
                                disabled={isLoading}
                                style={{paddingLeft: '1px', width: '110px'}}
                            >
                                {isLoading ? 'Loading...' : 'Sign in'}
                            </Button>
                        </td>
                    </tr>
                    <tr>
                        <td/>
                        <td>
                            <RegistrationLink style={{ paddingLeft: '1px' }} to="/register">
                                Sign up
                            </RegistrationLink>
                        </td>
                    </tr>
                </StyledTable>
            </Form>

        </Container>
    );
};
